// 日语
const userModule = {
  user: "マイページ",
  userName: "会員名",
  userInfo: "お客様情報",
  phone: "電話番号",
  sex: "性别",
  updatePassword: "パスワード",
  myOrder: "注文一覧",
  myCoupon:"クーポン券",
  aboutService: "このサービスについて",
  rule1: "利用規約",
  rule2: "プライバシーポリシー",
  returnLogin: "ログアウトする",
  sex0: "非公開",
  sex1: "男",
  sex2: "女",
  email: "メール",
};
export default userModule;
